import { gql } from "@apollo/client";

export default gql`
  mutation deleteAiHelpArticle($data: AiHelpArticleInput!){
    deleteAiHelpArticle(data: $data){
        success
        data
        code
        message
    }
}
`
